import { render, staticRenderFns } from "./GeographicalDistributionCards.vue?vue&type=template&id=594450f5&"
import script from "./GeographicalDistributionCards.vue?vue&type=script&lang=js&"
export * from "./GeographicalDistributionCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports